import type { WorkflowEdgeProps, WorkflowEdgeType } from 'flow/service/graph';
import NormalEdge from './NormalEdge';
import SkeletonEdge from './SkeletonEdge';
import PreviewEdge from './PreviewEdge';

const edgeTypes: Record<WorkflowEdgeType, React.ComponentType<WorkflowEdgeProps>> = {
  normal: NormalEdge,
  skeleton: SkeletonEdge,
  preview: PreviewEdge,
};

export default edgeTypes;
